import axios from "axios";
import React, {useContext, useEffect } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { UserContext } from "../../context/UserContext";
import Spinner from "../sample/spinner";
const PayRed = (props) => {
  const context = useContext(UserContext);
  let history = useHistory();
  useEffect(() => {
    Redirection()
  }, []);// eslint-disable-line react-hooks/exhaustive-deps
  const logindata = {
    encResp: "",
    order: "",
  };
  const Redirection = () => {
    const query = new URLSearchParams(props.location.search);
    logindata.encResp = query.get("_k");
    logindata.order = query.get("_o");
    axios
      .post("Login/relogin2", { logindata })
      .then((res) => {
        if (res.data.status === "200" && res.data.message === "success") {
          toast.success("Login Success!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          localStorage.setItem("user", res.data.user);
          localStorage.setItem("encordertoken", query.get("_o"));
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("usertype", res.data.ut);
          localStorage.setItem("name", res.data.name);
          localStorage.setItem("initial", res.data.initial);
          // localStorage.setItem("data", JSON.stringify(res.data.mydata));
          context.setUser({ email: res.data.user, token: res.data.token });
          history.push({
            pathname: "/transactionreceipt"
          });
          return res;
        } else if (
          res.data.status === "200" &&
          res.data.message !== "success"
        ) {
          toast.error(res.data.message, {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          history.push({
            pathname: "/signin"
          });
          return res;
        } else if (res.data.status) {
          toast.error("Login-Blocked,Contact Admin", {
            position: toast.POSITION.BOTTOM_LEFT,
          }); 
          history.push({
            pathname: "/signin"
          });
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  return (
    <div>
      <br />
      <br />
      <br />
    
      <br />
      <br />
      <br />
      <Spinner/>
      <center>Please Wait while Redirecting..</center>
      <br /><br />
      <br />
      <br />
      <br />
      <br /><br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default PayRed;
